export * from './ProductDetailsText';
